import React, {FC, useEffect, useState} from "react";
import {DropDownCompString, getKeyVal} from "../util/DropDownComp";
import {Position} from "../../models/Position";
import TickManager from "../../service/TickManager";
import AppUtil from "../../util/AppUtil";
import AppConstants from "../../util/AppConstants";
import {OptionWrapper} from "../../models/SGB";
import CollectionUtils from "../../util/CollectionUtils";

interface Props {
    // chain:string,
}

const Head : FC = () => {
    return<thead>
    <tr>
        <th>tradingSymbol</th>
        <th>qty</th>
        <th>price</th>
        <th>sqOffPrice</th>
        <th>intrinsic</th>
        <th>extrinsicBuy</th>
        <th>extrinsicSell</th>
        <th>profit</th>
        <th>expiryCashflow</th>
    </tr>
    </thead>
}

export default function AnalyseComp(props: { positions:Array<Position> }) {
    let positions = props.positions
    let optionsMap = new Map(positions.map(it=>TickManager.getOption(it.tradingsymbol)).map(it=>[it.genInfo.tradingsymbol, new OptionWrapper(it)]))
    const [expiryPrice, setExpiryPrice] = useState(0)
    const [type, setType] = useState("")
    const fraction = parseInt(""+(expiryPrice*0.5/100))
    const [_, refresh] = useState(0)
    useEffect(()=>{
        setExpiryPrice(TickManager.getFuture(positions[0].tradingsymbol)?.miniTick.lastPrice ?? 0)
    }, [props])
    let profits = 0
    let expiryCashflow = 0
    let expiryQty = 0

    function getPos() {
        let types = [type, AppConstants.FUT]
        return positions
            .filter(it => type==="" || types.indexOf(TickManager.getOption(it.tradingsymbol).genInfo.instrument_type)!==-1 )
    }

    let count = 0
    let trs = getPos()
        .map(row => {
        let setQty = (qty:number)=> {
            row.quantity = qty
            refresh(AppUtil.currentTime)
        }
        let symbol = row.tradingsymbol;
        let optionW = optionsMap.get(symbol)!!;
        let intrinsic = optionW.getIntrinsic(expiryPrice);
        let hidden = optionW.option.genInfo.hidden_lot_size;
        let qty = row.quantity;
        let profit = (intrinsic - row.average_price)*qty*hidden;
        profits+=profit
        let cf = intrinsic*qty*hidden;
        if (optionW.option.genInfo.instrument_type===AppConstants.FUT)cf = profit
        if (optionW.getIntrinsic(expiryPrice)>0){
            if (optionW.option.genInfo.instrument_type===AppConstants.PE){
                expiryQty+=(-qty*hidden)
            }else{
                expiryQty+=(qty*hidden)
            }
        }
        let sqOff
        if (qty>0){
            sqOff = AppUtil.maxBuyer(optionW.option)
        }else{
            sqOff = AppUtil.minSeller(optionW.option)
        }
        expiryCashflow+=cf
        let font = intrinsic>0 ? "bold" : "italic"
        count+=row.quantity
        return <>
            <tr>
                <td style={{fontWeight : font}}>{symbol}</td>
                <td><button onClick={()=>setQty(qty-1)}>-</button>{qty*hidden}<button onClick={()=>setQty(qty+1)}>+</button></td>
                <td>{AppUtil.getRoundedOff(row.average_price)}</td>
                <td>{AppUtil.getRoundedOff(sqOff)}</td>
                <td>{AppUtil.getRoundedOff(intrinsic)}</td>
                <td>{AppUtil.getRoundedOff(row.extrinsicBuy)}</td>
                <td>{AppUtil.getRoundedOff(row.extrinsicSell)}</td>
                <td>{AppUtil.getRoundedOff(profit)}</td>
                <td>{AppUtil.getRoundedOff(cf)}</td>
                <td>{count}</td>
            </tr>
        </>
    })
    const retVal = <>
        <DropDownCompString text={"type"} actual={type} arr={getKeyVal([AppConstants.FUT, AppConstants.CE, AppConstants.PE])} set={setType}/>
        <button onClick={()=>setExpiryPrice(expiryPrice-(fraction))}>-</button>
        expiryPrice : <input type={"number"} value={expiryPrice} onChange={event => setExpiryPrice(parseFloat(event.target.value))}/>
        <button onClick={()=>setExpiryPrice(expiryPrice+(fraction))}>+</button>
        <Head></Head>
        <tr>
            <td>Symbol</td>
            <td>{expiryQty}</td>
            <td>profit</td>
            <td>{AppUtil.getRoundedOff(profits)}</td>
            <td>expiryCashflow</td>
            <td>{AppUtil.getRoundedOff(expiryCashflow)}</td>
        </tr>
        {trs}
    </>
    return <>
        {retVal}
        <tr>
            <td>Symbol</td>
            <td>{CollectionUtils.sumOf(getPos(), "quantity")}</td>
            <td>profit</td>
            <td>--</td>
            <td>expiryCashflow</td>
            <td>--</td>
        </tr>
        </>

}

